export const HOST_ACCESS_REFUSAL_STORAGE_KEY = 'HOST_ACCESS_REFUSED';

/**
 * A refusal decided away from the login screen — a magic link opened on a partner address
 * the account is not part of (see useHostAccessGuard) — carried to the login screen that
 * renders next, so it shows the same alert and "Continue to" button the sign-in form does
 * instead of a toast that is gone before it is read.
 *
 * sessionStorage: per tab and per origin, so it cannot outlive the tab or reach another
 * host, and it is taken exactly once.
 */
export function rememberHostAccessRefusal({ homeUrl = null } = {}) {
  try {
    window.sessionStorage.setItem(HOST_ACCESS_REFUSAL_STORAGE_KEY, JSON.stringify({ homeUrl }));
  } catch {
    // Storage unavailable (privacy mode, quota) — the toast still said it.
  }
}

/** The refusal left for this screen, cleared on read; null when there is none. */
export function takeHostAccessRefusal() {
  try {
    const raw = window.sessionStorage.getItem(HOST_ACCESS_REFUSAL_STORAGE_KEY);

    if (!raw) {
      return null;
    }

    window.sessionStorage.removeItem(HOST_ACCESS_REFUSAL_STORAGE_KEY);
    const parsed = JSON.parse(raw);

    return { allowed: false, homeUrl: typeof parsed?.homeUrl === 'string' ? parsed.homeUrl : null };
  } catch {
    return null;
  }
}
